import { z } from 'zod';

/** A schema's shape with every field optional and its default dropped. */
type PatchShape<S extends z.ZodRawShape> = { [K in keyof S]: z.ZodOptional<S[K] extends z.ZodDefault<infer I> ? I : S[K]> };

/**
 * The schema for a partial update of `schema`: every field optional, and no
 * defaults. `schema.partial()` is not that in zod 4: it keeps the defaults,
 * so a patch naming one field parses to an object with all the others at
 * their default, and merging it over the stored value resets them.
 */
export function patchSchema<S extends z.ZodRawShape>(schema: z.ZodObject<S>): z.ZodObject<PatchShape<S>> {
  const shape = Object.fromEntries(Object.entries(schema.shape).map(([k, v]) => [k, z.optional(v instanceof z.ZodDefault ? v.unwrap() : v)]));
  return z.object(shape) as unknown as z.ZodObject<PatchShape<S>>;
}
